// Styled Components
import styled from "styled-components";

// Components
import InfoThreeUzi from "./InfoThreeUzi/InfoThreeUzi";

const InfoThree = () => {
  return (
    <Wrapper>
      <InfoThreeUzi
        img={
          "https://cdn.discordapp.com/attachments/896285560094748713/908856617620086784/p1.png"
        }
      />
      <InfoThreeUzi
        img={
          "https://media.discordapp.net/attachments/896285560094748713/908858835010215996/p2.png?width=703&height=701"
        }
      />

      <div className="break">=</div>

      <InfoThreeUzi
        img={
          "https://cdn.discordapp.com/attachments/896285560094748713/909552252451164200/PrestoComplete_1.mp4"
        }
        video={true}
      />
    </Wrapper>
  );
};

export default InfoThree;

const Wrapper = styled.div`
  width: 100%;
  padding: 0 20px;
  padding-top: 50px;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 25px;

  @media only screen and (max-width: 1250px) {
    flex-direction: column;
  }

  .main {
    //
    width: 550px;
    @media only screen and (max-width: 1600px) {
      width: 525px;
    }
    @media only screen and (max-width: 1400px) {
      width: 500px;
    }
    @media only screen and (max-width: 1300px) {
      width: 475px;
    }
    @media only screen and (max-width: 1250px) {
      width: 525px;
    }
    @media only screen and (max-width: 550px) {
      width: 100%;
    }
    //
  }

  .break {
    //  height: 600px;
    //   margin: 10px;
    //   width: 2.5px;

    font-size: 5rem;

    @media only screen and (max-width: 1250px) {
    }
  }
`;
